import { Link } from "react-router-dom";
import { Heart, Trash2 } from "lucide-react";
import { useSaved } from "@/context/SavedContext";
import { priceLabel } from "@/lib/format";
import { Button } from "@/components/ui/button";
import { PageHero } from "./About";

export default function SavedProperties() {
  const { saved, removeSaved } = useSaved();

  return (
    <div>
      <PageHero kicker="Your shortlist" title="Saved properties" subtitle="Properties you've saved are stored on this device." />
      <div className="max-w-6xl mx-auto px-5 sm:px-8 py-14">
        {saved.length === 0 ? (
          <div className="text-center py-20 bg-white rounded-2xl border border-border" data-testid="saved-empty">
            <div className="w-16 h-16 rounded-full bg-muted flex items-center justify-center mx-auto"><Heart className="w-7 h-7 text-muted-foreground" /></div>
            <h3 className="mt-4 font-display text-xl font-bold text-[#111827]">No saved properties yet</h3>
            <p className="mt-2 text-muted-foreground">Tap the heart on any property to save it here.</p>
            <Link to="/properties"><Button className="mt-5 rounded-full bg-[#C81D35] hover:bg-[#a5162b]">Browse properties</Button></Link>
          </div>
        ) : (
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {saved.map((p) => (
              <div key={p.id} className="bg-white rounded-2xl border border-border overflow-hidden" data-testid={`saved-${p.id}`}>
                <Link to={`/property/${p.slug}`} className="block aspect-[4/3] bg-muted">{p.image && <img src={p.image} alt={p.title} className="w-full h-full object-cover" />}</Link>
                <div className="p-5">
                  <p className="text-lg font-extrabold tracking-tight text-[#C81D35] font-body">{priceLabel(p)}</p>
                  <Link to={`/property/${p.slug}`}><h3 className="font-body font-bold text-[#111827] line-clamp-1">{p.title}</h3></Link>
                  <p className="text-sm text-muted-foreground">{[p.area, p.town].filter(Boolean).join(", ")}</p>
                  <Button variant="outline" size="sm" className="mt-4 rounded-full gap-2 text-[#C81D35] border-[#C81D35]/30" onClick={() => removeSaved(p.id)} data-testid={`remove-saved-${p.id}`}>
                    <Trash2 className="w-4 h-4" /> Remove
                  </Button>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
